if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.clickBehavior = this.dataset.clickBehavior || 'link';

        this.setupClickBehavior();
      }

      setupClickBehavior() {
        if (this.clickBehavior !== 'add_to_cart') return;
        
        this.querySelectorAll('a').forEach((anchor) => {
          anchor.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.clickBehavior === 'add_to_cart') {
              const addToCartButton = this.querySelector('product-form button[type="submit"]');
              if (addToCartButton) {
                addToCartButton.click();
              }
            }
          });
        });
      
      }
    },
  );
}
